import {
  Cpu,
  Cloud,
  ShieldCheck,
  Palette,
  MonitorSmartphone,
  Megaphone,
  BrainCircuit,
  Headset,
  Lightbulb,
} from "lucide-react";

export const services = [
  {
    slug: "computer-accessories-sales",
    icon: Cpu,
    title: "Computer & Accessories Sales",
    label: "Computer Sales",
    short:
      "Curated laptops, workstations, networking gear and peripherals sourced and configured for your needs.",
    span: "md:col-span-7",
    img: "https://images.unsplash.com/photo-1510519138101-570d1dca3d66?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    intro:
      "From single machines to full office fleets, we source, configure and deliver the right hardware for your business — at the right price, ready to work out of the box.",
    features: [
      "Business laptops, desktops and high-performance workstations",
      "Networking equipment, servers and storage",
      "Peripherals, accessories and genuine components",
      "Pre-configuration, imaging and on-site setup",
    ],
  },
  {
    slug: "cloud-solutions",
    icon: Cloud,
    title: "Cloud Solutions",
    label: "Cloud Solutions",
    short: "Migration, architecture and managed cloud infrastructure that scales with you.",
    span: "md:col-span-5",
    img: "https://images.unsplash.com/photo-1680992044138-ce4864c2b962?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    intro:
      "We design, migrate and manage cloud environments that are secure, cost-efficient and built to scale — so your team can focus on the business, not the servers.",
    features: [
      "Cloud migration and architecture planning",
      "AWS, Azure and Google Cloud deployments",
      "Backup, disaster recovery and high availability",
      "Ongoing monitoring and cost optimization",
    ],
  },
  {
    slug: "cybersecurity",
    icon: ShieldCheck,
    title: "Cybersecurity",
    label: "Cybersecurity",
    short: "Threat assessment, monitoring and hardening to keep your business protected.",
    span: "md:col-span-5",
    img: "https://images.unsplash.com/photo-1767481626727-2131a5212efc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    intro:
      "Protect your data, devices and reputation. We assess your risk, harden your systems and monitor for threats around the clock.",
    features: [
      "Security assessments and vulnerability scans",
      "Endpoint protection and network hardening",
      "Email security, MFA and access controls",
      "24/7 monitoring and incident response",
    ],
  },
  {
    slug: "creative-design",
    icon: Palette,
    title: "Creative Design",
    label: "Creative Design",
    short: "Branding, UI/UX and visual identity that make your product unforgettable.",
    span: "md:col-span-7",
    img: "https://images.unsplash.com/photo-1517336714731-489689fd1ca8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    intro:
      "Great technology deserves great design. We craft brands, interfaces and visuals that are clean, memorable and true to who you are.",
    features: [
      "Brand identity, logos and style guides",
      "UI/UX design for web and mobile",
      "Marketing, print and social media assets",
      "Design systems and prototyping",
    ],
  },
  {
    slug: "website-design",
    icon: MonitorSmartphone,
    title: "Website Design",
    label: "Website Design",
    short: "Fast, responsive websites and web apps — from concept and UI to launch.",
    span: "md:col-span-4",
    img: "https://images.unsplash.com/photo-1559028012-481c04fa702d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    intro:
      "We build fast, responsive and beautiful websites and web apps — designed to convert visitors and easy for you to manage.",
    features: [
      "Responsive marketing sites and landing pages",
      "Custom web applications and portals",
      "SEO-friendly, accessible and performance-optimized",
      "Hosting, maintenance and content updates",
    ],
  },
  {
    slug: "social-media-digital-marketing",
    icon: Megaphone,
    title: "Social Media & Digital Marketing",
    label: "Digital Marketing",
    short: "Grow your brand online with content, campaigns and data-driven marketing.",
    span: "md:col-span-4",
    img: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    intro:
      "Reach the right audience and grow your brand. We manage your social presence and run performance campaigns that turn attention into customers.",
    features: [
      "Social media management and content creation",
      "Paid ads on Google, Meta, Instagram and LinkedIn",
      "SEO, email marketing and campaign strategy",
      "Analytics, reporting and performance optimization",
    ],
  },
  {
    slug: "artificial-intelligence",
    icon: BrainCircuit,
    title: "Artificial Intelligence",
    label: "AI Solutions",
    short: "Custom AI, chatbots and automation that make your business smarter.",
    span: "md:col-span-4",
    img: "https://images.unsplash.com/photo-1620712943543-bcc4688e7485?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    intro:
      "Put AI to work for your business. We build intelligent assistants, automations and data-driven tools that save time, cut costs and unlock new capabilities.",
    features: [
      "AI chatbots and virtual assistants",
      "Workflow automation and integrations",
      "Custom AI models and data analytics",
      "AI strategy, adoption and training",
    ],
  },
  {
    slug: "it-support",
    icon: Headset,
    title: "IT Support",
    label: "IT Support",
    short: "Responsive, around-the-clock helpdesk and on-site engineering.",
    span: "md:col-span-6",
    img: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    intro:
      "Keep your team productive with responsive support. Whether remote or on-site, our engineers resolve issues fast and keep everything running.",
    features: [
      "Remote and on-site helpdesk support",
      "Proactive maintenance and monitoring",
      "Device setup, repairs and diagnostics",
      "Flexible support plans with fast response times",
    ],
  },
  {
    slug: "it-consulting",
    icon: Lightbulb,
    title: "IT Consulting",
    label: "IT Consulting",
    short: "Strategic guidance to align technology with your business goals.",
    span: "md:col-span-6",
    img: "https://images.unsplash.com/photo-1531297484001-80022131f5a1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    intro:
      "Make confident technology decisions. We help you plan, budget and implement the right solutions to move your business forward.",
    features: [
      "Technology strategy and roadmapping",
      "Infrastructure and software assessments",
      "Vendor-agnostic recommendations",
      "Project planning and implementation oversight",
    ],
  },
];

export const getService = (slug) => services.find((s) => s.slug === slug);
